import XLSX from "xlsx";
function importToExcel(file, list, callback) {
  let arr = JSON.parse(JSON.stringify(list));
  // 读取本地excel文件
  if (!file) return;
  var rABS = false; //是否将文件读取为二进制字符串
  var f = file;
  var reader = new FileReader();
  console.log(reader);
  var outdata;
  try {
    FileReader.prototype.readAsBinaryString = function(f) {
      var binary = "";
      var rABS = false; //是否将文件读取为二进制字符串
      var wb; //读取完成的数据
      var reader = new FileReader();
      reader.onload = function(e) {
        var bytes = new Uint8Array(reader.result);
        var length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        // var XLSX = require('xlsx');
        if (rABS) {
          wb = XLSX.read(btoa(fixdata(binary)), {
            //手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(binary, {
            type: "binary"
          });
        }
        // outdata就是你想要的东西 excel导入的数据
        // 将返回的数据转换为json对象的数据
        outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        //处理得到的结果
        callback(dealImportData(outdata, arr));
      };
      reader.readAsArrayBuffer(f);
    };
    if (rABS) {
      reader.readAsArrayBuffer(f);
    } else {
      reader.readAsBinaryString(f);
    }
  } catch (error) {
    alert("导入失败");
  }
  console.log("outdata", outdata);
  return outdata;
}
//处理得到的结果
function dealImportData(outdata, arr) {
  var columns = arr;
  var tHeader = {};
  columns.map(item => {
    if (item.key) {
      tHeader[item.key] = item.title;
    }
  });

  var dataList = [];
  outdata.map((item, index) => {
    var obj = {};
    for (var i in item) {
      for (var j in tHeader) {
        if (i == tHeader[j]) {
          obj[j] = item[i];
        }
      }
    }
    dataList.push(obj);
  });

  return dataList;
}
export default {
  importToExcel
};



// WEBPACK FOOTER //
// ./src/util/ExcelImportActiveGroup.js